import { aboutData } from '@/mocks/homepage';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-building-2-line text-sm"></i>
            </div>
            关于我们
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading mb-3">
            {aboutData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            了解91视频网站背后的故事，探索久久视频与91在线视频的内容世界
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
            {aboutData.sections.map((section) => (
              <div key={section.subtitle}>
                <h3 className="text-lg font-bold text-foreground-900 font-heading mb-3 flex items-center gap-2">
                  <div className="w-1.5 h-5 rounded-full bg-accent-500 flex-shrink-0"></div>
                  {section.subtitle}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}